import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts/highcharts';
import exporting from 'highcharts/modules/exporting';
exporting(Highcharts);
// import Drilldown from 'highcharts/modules/drilldown';
// Drilldown(Highcharts);
// import highcharts3D from 'highcharts/highcharts-3d';
// highcharts3D(Highcharts);
// import HC_more from 'highcharts/highcharts-more';
// HC_more(Highcharts);
// import HC_accessibility from 'highcharts/modules/accessibility'
// HC_accessibility(Highcharts);
// import HC_bullet from 'highcharts/modules/bullet';
// HC_bullet(Highcharts);
// import HC_solidgauge from 'highcharts/modules/solid-gauge';
// HC_solidgauge(Highcharts);
// import HC_venn from 'highcharts/modules/venn';
// HC_venn(Highcharts);
// import HC_wordcloud from 'highcharts/modules/wordcloud';
// HC_wordcloud(Highcharts);
// import HC_heatmap from 'highcharts/modules/heatmap';
// HC_heatmap(Highcharts);
// import HC_timeline from 'highcharts/modules/timeline';
// HC_timeline(Highcharts);
// import tilemap from 'highcharts/modules/tilemap';
// tilemap(Highcharts);
// import xrange from 'highcharts/modules/xrange';
// xrange(Highcharts)
// import item from 'highcharts/modules/item-series';
// item(Highcharts)
// import dumbbell from 'highcharts/modules/dumbbell';
// dumbbell(Highcharts)
// import Cylinder from 'highcharts/modules/cylinder';
// Cylinder(Highcharts);

Highcharts.setOptions({
  credits: {
    enabled: false,
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: ['viewFullscreen'],
      },
    },
    enabled: true,
  },
});

@Injectable({
  providedIn: 'root'
})
export class ChartsService {
  highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  
  constructor() { }

  json(name: any[] ,list: any[]) {
    let jsonList: any[] = [];
    for (let i = 0; i < list.length; i++) {
      let json: JSON = <JSON>(<unknown>{
        name: name[i],
        y: list[i],
      });
      jsonList.push(json);
    }
    return jsonList;
  }
  
}
